<template>
  <media-preview v-if="id && model" v-model="model"/>
</template>

<script>
import { mapState } from 'vuex'
import mediaApi from '@/api/media'
import mediaPreview from './media-preview'

export default {
  components:{
    mediaPreview
  },
  props: {
    value: { type: null, default: '' },
    id: { type: String, required: true }
  },
  computed: {
    ...mapState('tenants', {
      tenant: 'current'
    }),
    model: {
      get() {
        return this.value
      },
      set(model) {
        this.$emit('input', model)
      }
    }
  },
  watch: {
    model(val) {
      this.$emit('input', val)
    },
    value(val) {
      this.model = val
    }, 
    id(val){
      this.loadMedia(val,true)
    }
  },
  mounted(){
    this.loadMedia(this.id, true)
  },
  methods: {
    async loadMedia(id,refresh){
      if(refresh || !this.model){
        const response = await mediaApi.show({tenantID: this.tenant.id, mediaID: id})
        this.model = response.data.data
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/common/media/object-media-preview.vue